export default __webpack_public_path__ + "static/affiliate-program-Software-1@mob2x-7dbd809093fd7adb39370928ae884a3c.webp";